import React from "react";
import { useParams, Link } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class VermultaContenido extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            datosCargados: false,
            multa: null,
            infracciones: []
        };
    }

    componentDidMount(){
        this.cargarDatos();
    }

cargarDatos() {
    fetch(api + "multas/" + this.props.idmulta, {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        this.setState({
            datosCargados: true,
            multa: datosRespuesta.multa || null,
            infracciones: datosRespuesta.infracciones || []
        });

    })
    .catch(error => {
        

        this.setState({
            datosCargados: true,
            multa: null,
            infracciones: []
        });
    });
}

    render(){

        const usuario = JSON.parse(localStorage.getItem("usuario"));
        const rol = Number(usuario?.rol);

        const {
            datosCargados,
            multa,
            infracciones
        } = this.state;

        if(!datosCargados){
    return <div>Cargando...</div>;
}

if(!multa){
    return (
        <div className="alert alert-warning">
            No se encontró la multa o hubo un error al cargar los datos.
        </div>
    );
}

        return(

            <div className="container mt-4">

                <div className="card shadow">

                    <div className="card-header bg-dark text-white">

                        <div className="d-flex justify-content-between align-items-center">

                            <div>
                                 <h4 className="mb-1">
                                     MULTA No. {multa.idmulta}
                                 </h4>

                                 <span className={
                                     Number(multa.estadomulta) === 1
                                     ? "badge bg-warning text-dark"
                                        : "badge bg-success"
                                     }>
                                     {multa.estado_multa}
                                 </span>
                            </div>

                         <div className="d-flex gap-2">

                           {Number(multa.estadomulta) === 1 && (rol === 1 || rol === 2) &&(
                              <Link
                                  to={"/pagarmulta/" + multa.idmulta}
                                 className="btn btn-success btn-sm"
                              >
                                 Pagar multa
                            </Link>
                                )}

            <Link
                to="/listarmultas"
                className="btn btn-light btn-sm"
            >
                Volver
            </Link>

        </div>

    </div>

</div>

                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-2">
                                <strong>Placa:</strong><br />
                                {multa.tipoplaca}{multa.placa}
                            </div>

                            <div className="col-md-2">
                                <strong>Modelo:</strong><br />
                                {multa.modelo}
                            </div>

                            
                            <div className="col-md-2">
                                <strong>Marca:</strong><br />
                                {multa.marca}
                            </div>
                            <div className="col-md-2">
                                <strong>Color:</strong><br />
                                {multa.color}
                            </div>
                            <div className="col-md-2">
                                <strong>Fecha:</strong><br />
                                {multa.fecha}
                            </div>
                            <div className="col-md-2">
                                <strong>Hora:</strong><br />
                                {multa.hora}
                            </div>
                            <div className="col-md-6">
                                <strong>Lugar:</strong><br />
                                {multa.lugar}
                            </div>

                        </div>

                        <hr />

                        <div className="row">

                            <div className="col-md-3">
                                <strong>Conductor:</strong><br />
                                {multa.nombrec}
                            </div>

                            <div className="col-md-2">
                                <strong>DPI:</strong><br />
                                {multa.dpi}
                            </div>
                            
                            <div className="col-md-2">
                                <strong>Tipo Licencia:</strong><br />
                                {multa.tipolicencia}
                            </div>
                            <div className="col-md-2">
                                <strong>Agente:</strong><br />
                                {multa.nochapa}
                            </div>

                    <div className="col-md-12">
    <label>Observaciones</label>
    <textarea
    className="form-control"
    rows="4"
    value={multa.observaciones || ""}
    readOnly
/>
</div>

                     
                        </div>

                        <hr />

                        <h5>Infracciones</h5>

                        <table className="table table-bordered">

                            <thead className="table-dark">

                                <tr>
                                    <th>Artículo</th>
                                    <th>Inciso</th>
                                    <th>Descripción</th>
                                    <th>Monto</th>
                                </tr>

                            </thead>

                            <tbody>

                                {infracciones.map((infraccion) => (

                                    <tr key={infraccion.idinfraccion}>

                                        <td>{infraccion.articulo}</td>

                                        <td>{infraccion.inciso}</td>

                                        <td>{infraccion.descripcion}</td>

                                        <td>
                                            Q. {infraccion.montoinfraccion}
                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                        <div className="text-end">

                            <h4>
                                TOTAL: Q. {multa.monto}
                            </h4>

                        </div>

                        {multa.foto && (
    <div className="mt-4">
        <h5>Evidencia fotográfica</h5>

        <img
            src={multa.foto}
            //src={`https://pmt-chiantla.jgjsystems.com/storage/${this.state.multa.foto}`}
            alt="Evidencia de la multa"
            className="img-fluid rounded border"
            style={{ maxWidth: "450px" }}
        />
    </div>
)}
       

                    </div>

                </div>

            </div>
        );
    }
}

function Vermulta(){

    const { idmulta } = useParams();

    return <VermultaContenido idmulta={idmulta} />;
}

export default Vermulta;